export default __webpack_public_path__ + "static/media/sign.a2d5c5f1.gif";